import React from 'react'
import { useTranslation } from '../../utils/convergence'
import { Text, Icon } from '@afterpaytouch/core'
import { useGetIsAutoPayAgreed } from './hooks'
import style from './styles.module.css'
import { useCountry, useIsAfterpayFinanceFeeEligible } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import { Country } from '@afterpay/types'

export const AutopayButtonToggleText: React.FC = () => {
  const { t } = useTranslation()
  const isAFF = useIsAfterpayFinanceFeeEligible()
  const autoPayAgreed = useGetIsAutoPayAgreed() ?? false
  const country = useCountry()
  const isTreatmentCountry = [Country.US, Country.CA].includes(country)
  const { smallTextSize } = useCheckoutSizes()

  return (
    <div className={style.toggleTextWrapper} data-testid='autopay-button-toggle-text'>
      <span className={style.iconContainer}>
        <Icon name='RecurringAutomatic' size='Small' />
      </span>
      <Text bold size={smallTextSize} renderAs='span'>
        {isTreatmentCountry ? t('consumerLending:autopay.name', { context: isAFF ? 'aff' : '' }) : t('summary:autopay.name', { context: isAFF ? 'aff' : '' })}
      </Text>
      <span className={style.toggleText}>
        <Text size={smallTextSize} renderAs='span' color={autoPayAgreed ? 'Standard' : 'Danger'}>
          {t('summary:autopay.toggle.enabled', {
            context: autoPayAgreed.toString(),
          })}
        </Text>
      </span>
    </div>
  )
}
